import * as React from "react";
import InputOptions from "./InputOptions";
import PickerContainer from "./PickerContainer";

export type DropdownOption<T extends string> = {
  value: T;
  label: string;
};

export type DropdownProps<T extends string> = {
  label: string;
  value: T;
  options: ReadonlyArray<DropdownOption<T>>;
  onChange: (value: T) => void;
  className?: string;
  placeholder?: string;
};

export default function Dropdown<T extends string>({
  label,
  value,
  options,
  onChange,
  className,
  placeholder,
}: DropdownProps<T>) {
  const selectedLabel =
    options.find((o) => o.value === value)?.label ?? String(value);

  return (
    <InputOptions
      className={className}
      value={String(value)}
      onChange={(v) => onChange(v as T)}
      options={options.map((o) => ({ value: String(o.value), label: o.label }))}
    >
      <PickerContainer
        label={label}
        value={selectedLabel}
        placeholder={placeholder}
      />
    </InputOptions>
  );
}
